// i18n area 'common' — locale pl-PL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.pl-PL.meta.json.
import type { enUS } from './common'

export const plPL: typeof enUS = {
  nav: {
    home: 'Strona główna',
    vms: 'Maszyny wirtualne',
    templates: 'Template',
    importVms: 'Importuj VM',
    containers: 'Kontenery',
    containersApps: 'Aplikacje',
    containersPods: 'Pody',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'Obrazy OCI',
    containersOciRegistries: 'Registry OCI',
    containersCtTemplates: 'Template CT',
    networkServices: 'Usługi sieciowe',
    firewall: 'Firewall',
    checkpoints: 'Checkpointy',
    backup: 'Backup',
    monitoring: 'Monitorowanie',
    cluster: 'Klaster',
    clusterSettings: 'Ustawienia globalne',
    clusterNodes: 'Węzły',
    clusterDevices: 'Zasoby USB i PCIe',
    clusterFederation: 'Federacja',
    network: 'Sieć',
    overlayNetworks: 'Sieci overlay',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Dane',
    storages: 'Storage',
    hci: 'Hiperkonwergencja',
    ceph: 'Ceph',
    system: 'System',
    tasks: 'Taski',
    events: 'Zdarzenia',
    audit: 'Audyt',
    diagnostics: 'Diagnostyka',
    notifications: 'Powiadomienia',
    proximity: 'TVirt Proximity',
    users: 'Użytkownicy i grupy',
    groups: 'Grupy',
    mfa: 'MFA',
    realms: 'Realm i SSO',
    rbac: 'Role i uprawnienia',
    credentials: 'Poświadczenia',
    scopes: 'Scope',
    tags: 'Tagi',
    explorer: 'Eksplorator',
    licensing: 'Licencja',
    information: 'Informacje'
  },
  mode: {
    light: 'Jasny',
    dark: 'Ciemny',
    system: 'Systemowy',
    tooltip: 'Motyw'
  },
  language: {
    tooltip: 'Język'
  },
  langRegion: {
    europe: 'Europa',
    northAmerica: 'Ameryka Północna',
    southAmerica: 'Ameryka Południowa',
    asia: 'Azja'
  },
  notFound: {
    title: 'Nie znaleziono strony',
    body: 'Ten adres nie odpowiada żadnej stronie TVirt — mógł się zmienić wraz z aktualizacją albo link jest nieaktualny.',
    backHome: 'Powrót na stronę główną'
  },
  scopeBrowser: {
    title: 'Scope',
    all: 'Cały klaster',
    noChildren: 'Brak podrzędnych scope',
    recursive: 'Uwzględnij podrzędne',
    collapse: 'Zwiń panel scope',
    openPicker: 'Przeglądaj scope',
    up: 'Poziom wyżej',
    countTooltip: '{direct} w tym scope · {total} z podrzędnymi'
  },
  search: {
    tooltip: 'Szukaj (⌘K)',
    placeholder: 'Szukaj VM, sieci, storage…',
    empty: 'Brak wyników',
    groups: {
      recent: 'Ostatnie',
      shortcuts: 'Skróty',
      actions: 'Akcje',
      goTo: 'Przejdź do'
    },
    kind: {
      catalog: 'Katalog',
      scope: 'Scope',
      node: 'Węzeł'
    },
    footer: {
      navigate: 'nawiguj',
      open: 'otwórz',
      close: 'zamknij'
    },
    actions: {
      createVm: 'Utwórz VM…',
      uploadIso: 'Wgraj ISO…',
      clusterSettings: 'Ustawienia klastra',
      consoleOf: 'Przejdź do konsoli {name}'
    }
  },
  stub: {
    containersSummary: 'Aplikacje i kontenery systemowe (CT) wraz z ich obrazami OCI, registry i template — zarządzane obok maszyn wirtualnych.',
    sectionSummary_vms: 'Maszyny wirtualne i ich template — cykl życia, snapshoty, migracja i konsola.',
    sectionSummary_storages: 'Storage, na których znajdują się dyski, obrazy i metadane VM.',
    sectionSummary_catalogs: 'Miejsce artefaktów plikowych klastra: obrazy ISO, template CT i VM oraz archiwa OCI, uporządkowane w katalogi.',
    sectionSummary_overlay: 'Sieci overlay VXLAN między węzłami klastra.',
    sectionSummary_fabric: 'Inwentarz sieci fizycznej — switche, porty, LAGG i sieci logiczne.',
    sectionSummary_ipam: 'Adresacja wynikająca z sieci fabric i overlay: kto zajmuje dany adres.',
    sectionSummary_services: 'Serwery DHCP i DNS wynikające z rejestru sieci.',
    sectionSummary_ceph: 'Klastry Ceph zarządzane na węzłach TVirt.',
    sectionSummary_hci: 'Hiperkonwergentne technologie storage na węzłach TVirt.',
    sectionSummary_cluster: 'Węzły, przynależność i ustawienia klastra.',
    containers: 'Kontenery systemowe są w planach rozwoju — znajdą się w tej sekcji.',
    containersApps: 'Aplikacje kontenerowe są w planach rozwoju — znajdą się w tym obszarze.',
    containersPods: 'Pody grupują kontenery współdzielące sieć i wolumeny — instancje to aplikacje.',
    containersCt: 'Kontenery systemowe (CT) są w planach rozwoju — znajdą się w tym obszarze.',
    multiscsi: 'TVStor MultiSCSI jest w planach rozwoju — znajdzie się w tym obszarze.',
    clusterFederation: 'Federacja między klastrami TVirt jest w planach rozwoju — znajdzie się w tym obszarze.',
    containersOciImages: 'Obrazy OCI są w planach rozwoju — znajdą się w tym obszarze.',
    containersOciRegistries: 'Registry OCI są w planach rozwoju — znajdą się w tym obszarze.',
    containersCtTemplates: 'Template CT są w planach rozwoju — znajdą się w tym obszarze.',
    importVms: 'Tu trafią importery z ESXi i Proxmox: konwersja systemów gościa i migracja masowa do TVirt.',
    backup: 'Wbudowany backup pojawi się w wersji 6.2: deduplikowane repozytoria content-addressed, przyrostowe kopie CBT, okna niezmienności i replikacja repo-do-repo.',
    monitoring: 'Ogólnoklastrowe dashboardy rywalizacji o zasoby (cpu.ready, presja PSI, wbudowane alerty) są w drodze — dziś te same metryki znajdują się w szczegółach każdej VM.'
  },
  home: {
    welcome: 'Zalogowano jako: {name}',
    subtitle: 'Klaster TVirt na pierwszy rzut oka.',
    loadError: 'Nie można wczytać przeglądu — czy backend TVirt jest osiągalny?',
    health: {
      ok: 'Wszystko w porządku',
      warning: 'Uwaga',
      critical: 'Problemy krytyczne'
    },
    reason: {
      'node-down': '{subject} jest wyłączony',
      'node-stale': '{subject} nie odzywa się od dłuższego czasu',
      'node-maintenance': '{subject} w trybie konserwacji',
      'tasks-failed': {
        one: '{n} nieudany task w ciągu ostatnich 24 h',
        few: '{n} nieudane taski w ciągu ostatnich 24 h',
        many: '{n} nieudanych tasków w ciągu ostatnich 24 h',
        other: '{n} nieudanego taska w ciągu ostatnich 24 h'
      },
      'storage-degraded': 'storage {subject} w stanie degradacji',
      'storage-error': 'storage {subject} w stanie błędu',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'store klastra nieosiągalny',
      'license-absent': 'brak licencji — nowe VM nie mogą wystartować',
      'license-expired': 'licencja wygasła — nowe VM nie mogą wystartować',
      'license-exceeded': 'przekroczony limit licencji — nowe VM nie mogą wystartować',
      'failover-reserve-eroded': 'rezerwa failover prawie wyczerpana',
      'failover-reserve-exhausted': 'rezerwa failover wyczerpana — nowe VM nie mogą wystartować',

      'oci-cache-nearly-full': 'cache OCI na {subject} prawie pełny — digesty usuwa się ręcznie',
      'oci-cache-full': 'cache OCI na {subject} pełny — żaden pull się nie powiedzie, dopóki digesty nie zostaną usunięte',
      'config-replica-empty': 'replika konfiguracji na {subject} jest PUSTA — węzeł nie ma konfiguracji klastra, dopóki replikacja się nie powiedzie',
      'config-replica-stalled': 'replikacja konfiguracji na {subject} stoi — lokalna kopia pozostaje w tyle za konfiguracją klastra'
    },
    staleChip: 'Dane nieaktualne',
    staleAsOf: 'ostatnia replika {time}',
    zone: {
      nodes: 'Węzły',
      failoverReserve: 'Rezerwa failover',
      capacity: 'Pojemność',
      workload: 'Obciążenie',
      protection: 'Ochrona',
      activity: 'Ostatnia aktywność'
    },

    // Strefa rezerwy failover (admission control N+1, task #133b).
    reserve: {
      state: {
        ok: 'Rezerwa nienaruszona',
        eroded: 'Rezerwa prawie wyczerpana',
        exhausted: 'Rezerwa wyczerpana',
        unknown: 'Rezerwa nieznana'
      },
      tolerate: {
        one: 'toleruje utratę {n} węzła',
        few: 'toleruje utratę {n} węzłów',
        many: 'toleruje utratę {n} węzłów',
        other: 'toleruje utratę {n} węzła'
      },
      usedOf: '{used} / {allowed} GiB w użyciu',
      keepFree: '{n} GiB utrzymywane jako wolne na potrzeby failover',
      expendable: 'w tym {n} do poświęcenia w działaniu',
      headroom: 'można jeszcze uruchomić {n} GiB',
      short: 'do rezerwy brakuje {n} GiB — nowe VM nie mogą wystartować',
      hp: {
        usedOf: 'Strony {size} — w użyciu: {used} / {allowed}',
        keepFree: 'utrzymywane jako wolne na potrzeby failover: {keep}',
        headroom: 'można jeszcze uruchomić: {n}',
        short: 'brakuje w rezerwie: {n} — nowe VM z ogromnymi stronami nie mogą wystartować'
      },
      worstCase: 'najgorszy przypadek: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Żaden węzeł nie zadeklarował jeszcze pamięci — rezerwy nie da się obliczyć i żadne uruchomienie nie jest odrzucane.',
      reason: {
        attestedDown: 'potwierdzony jako wyłączony',
        maintenance: 'w trybie konserwacji',
        unreachable: 'nieosiągalny',
        capacityUnknown: 'pamięć niezadeklarowana'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} rdzeni / {threads} wątków',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} aktywna VM',
        few: '{n} aktywne VM',
        many: '{n} aktywnych VM',
        other: '{n} aktywnej VM'
      },
      activeVmsUnknown: 'nieznana liczba aktywnych VM',
      lastSeen: 'widziany {time}',
      neverSeen: 'nigdy nie widziany',
      down: 'Wyłączony',
      maintenance: 'Konserwacja',
      stale: 'Nieosiągalny'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: 'zaaprowizjonowano {n} GiB',
      reserve: 'rezerwa {n} GiB',
      unobserved: 'pojemność jeszcze nieobserwowana',
      empty: 'Jeszcze brak storage'
    },
    workload: {
      vms: 'Maszyny wirtualne',
      apps: 'Aplikacje',
      services: 'Usługi sieciowe',
      empty: 'Jeszcze nic',
      phasesUnknown: 'podział na fazy niedostępny'
    },
    protection: {
      none: 'Nie skonfigurowano żadnego celu kopii zapasowych — zabezpiecz konfigurację.',
      configure: 'Skonfiguruj checkpointy',
      noRuns: 'Nie utworzono jeszcze żadnego checkpointu.',
      last: 'Ostatni checkpoint',
      onTarget: 'na {target}',
      viewAll: 'Checkpointy'
    },
    activity: {
      empty: 'Brak ostatniej aktywności',
      failed24: {
        one: '{n} nieudany w 24 h',
        few: '{n} nieudane w 24 h',
        many: '{n} nieudanych w 24 h',
        other: '{n} nieudanego w 24 h'
      },
      viewAll: 'Zobacz wszystkie taski'
    }
  },
  notes: {
    title: 'Notatki',
    tabEdit: 'Edycja',
    tabPreview: 'Podgląd',
    placeholder: 'Swobodne notatki operatora — Markdown jest renderowany w podglądzie',
    empty: 'Brak notatek',
    tooLarge: 'Notatki przekraczają limit 64 KiB',
    saveError: 'Nie udało się zapisać notatek'
  },
  common: {
    contractError: 'Odpowiedź backendu zawiera wartość, której ten interfejs nie zna: {field}={value} — zaktualizuj interfejs webowy do wersji backendu.',
    contractErrorItems: '{count} obiektów tej listy nie może zostać odczytanych przez ten interfejs ({field}={value}) i nie są pokazywane.',
    staleHint: 'Store jest nieosiągalny — to replika konfiguracji tego węzła; stan floty jest nieznany.',
    staleStateAge: 'stan na {time}',
    staleStateNever: 'stan nigdy nie otrzymany ze store: widzisz tylko obserwacje tego węzła',
    staleStateTooltip: 'Store klastra jest nieosiągalny: obserwowany stan (faza, węzeł, agent) pochodzi z repliki stanu tego węzła i odpowiada ostatniemu udanemu odczytowi ze store — może być nieaktualny.',
    noPermission: 'Brak uprawnień do tej akcji',
    actionStillRunning: 'Akcja wciąż trwa — wynik nie jest jeszcze znany',
    staleWrite: 'Ktoś inny zmienił ten obiekt, gdy go edytowałeś — nic nie zostało zapisane. Załaduj ponownie i powtórz zmianę na aktualnym stanie.',
    staleReload: 'Załaduj ponownie',
    preview: 'Podgląd',
    previewTitle: 'Podgląd wyniku',
    previewNothingWritten: 'Zasymulowano na serwerze — nic nie zostało zapisane.',
    previewChanged: 'Wyróżnione: wartości, które uległyby zmianie.'
  },
  context: {
    copySelection: 'Kopiuj zaznaczony tekst'
  },
  crud: {
    create: 'Utwórz',
    viewDetails: 'Zobacz szczegóły',
    viewOrEdit: 'Zobacz lub edytuj',
    selected: 'zaznaczonych',
    viewUsingVms: 'Zobacz VM używające tego zasobu',
    clearSelection: 'Odznacz',
    deleteSelected: 'Usuń zaznaczone',
    bulkConfirmBody: {
      one: 'Usunąć zaznaczony element ({count})? Jeśli jest chroniony, zostanie zgłoszony i zachowany.',
      few: 'Usunąć zaznaczone elementy ({count})? Elementy chronione zostaną zgłoszone i zachowane.',
      many: 'Usunąć zaznaczone elementy ({count})? Elementy chronione zostaną zgłoszone i zachowane.',
      other: 'Usunąć zaznaczone elementy ({count})? Elementy chronione zostaną zgłoszone i zachowane.'
    },
    bulkDeleted: 'usunięte',
    bulkRefused: 'odrzucone',
    fieldId: 'ID',
    createdAt: 'Utworzono',
    updatedAt: 'Zaktualizowano',
    immutableField: 'Ustalone przy tworzeniu — contract nie pozwala na zmianę',
    immutableScope: 'Scope przypisuje się przy tworzeniu; niektóre zasoby przenosi się dedykowaną akcją',
    observedField: 'Stan obserwowany — raportowany przez platformę, nie do edycji'
  }
}
